/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import { useNavigate, Link } from 'react-router-dom';
import Modal from 'react-modal';

const Step3 = ({ onBack, onNext, role, userEmail,token, formData, setFormData }) => {
   

    useEffect(() => {
        // Make the API call when the component mounts
      console.log(formData);
    }, [formData]);
    const [contacts, setContacts] = useState([
        { name: '', phone: '', extension: '', alias: '' }
    ]);
    const [validationErrors, setValidationErrors] = useState([]);
    const [loading, setLoading] = useState(true); 
    const [orderInstrunction, setOrderInstrunction] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [companyEmail, setCompanyEmail] = useState("");
    const [copmanyName, setCopmanyName] = useState("");
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    
    const navigate = useNavigate();
    useEffect(() => {
        if (validationErrors.length > 0) {
            const errorMessages = validationErrors.join('\n');
            alert(errorMessages);
        }
    }, [validationErrors]);
    useEffect(() => {
        getCompanyEmail();
    }, [formData.selectedCompany]);
    

     

    const getCompanyEmail = async () => {
        try {
            
            const response = await axios.get(`${baseUrl}/get-company-email/${formData.selectedCompany}`);
            console.log(response.data[0]);
            setCompanyEmail(response.data[0].email);
            setCopmanyName(response.data[0].name);
            
        } catch (error) {
           console.log(error);
            
        }
    }

    const toggleOrderInstruction = () => {
        setOrderInstrunction(!orderInstrunction);
    };

    const handleCheckboxChange = (event) => {
        setIsCheckboxChecked(event.target.checked);
    };

    const handleContactChange = (e, index) => {
        const { name, value } = e.target;
        const updatedContacts = [...contacts];
        const fieldName = name.split('-')[0];
        updatedContacts[index][fieldName] = value;
    
        setContacts(updatedContacts);
    };

    const contactInputs = contacts.map((contact, index) => (
        <div className="row order-contect" key={index}>
        <div className="labelwithbox" >
            <label>Name</label>
            <div className="inputbox">
                <input
                    type="text"
                    name={`name-${index}`}
                    value={contact.name}
                    onChange={(e) => handleContactChange(e, index)}
                    required
                />
            </div> </div>
            
                 <div className="labelwithbox">
                    <label>Email</label>
                    <div className="inputbox">
                        <input type="email" name={`alias-${index}`} value={contact.alias}
                    onChange={(e) => handleContactChange(e, index)} required />
                    </div>
                </div>
                
        </div>
       
    ));
    

    const handleNext = async(e) => {
        e.preventDefault();
        if(isCheckboxChecked == false && role > 2){
            alert("Please accept the disclaimer to proceed");
            return;
        }else{
            console.log(formData);
            console.log(contacts);
            try {
            
                setButtonDisabled(true);
                setPopupOpen(true);
                const response = await axios.post(`${baseUrl}/international-order-new-number`, {formData, contacts}, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }       
                });
                const allArray = response.data;
                console.log(allArray);
                setPopupOpen(false);
                navigate("/order-new-number-success", { state: allArray });  
            
            
            } catch (error) {
                setPopupOpen(false);
               console.log(error);

            }
        }
    
   
   
    };

    return(
   
    <>
        {popupOpen && (
            <div className='overlay'><div className="custom-loader"></div></div> // Display the loader while loading is true
        ) }
        <div className="row">
            <div className="col-6">
                <div className="left-title">
                    <h1>International Number Order </h1>
                    <small>(Order Summary Step 3)</small>
                </div>
            </div>
            <div className="col-6">
            </div>
        </div>
        <div className="common-white-shadow-background setting-section tableinput-section order-number-four-table">
            <div className="row">
                <div className="order-con-title">Secondary Order contact</div>
            </div>
            {contactInputs}
           
        </div>
        <div className="common-white-shadow-background setting-section tableinput-section order-number-four-table">
            <strong>Note:- </strong>Additional to secondary contact we will send order details to below email addresses.<br/>
            <ul>
                <li>{userEmail && userEmail}</li>
                <li>provisioning@broadbanddynamics.com</li>
                <li>{companyEmail && companyEmail}</li>
            </ul>
        </div>
        {role > 2 && <div className="common-white-shadow-background setting-section tableinput-section order-number-four-table">
            
            <label htmlFor="disclaimerCheckbox">
            <input
                type="checkbox"
                id="disclaimerCheckbox"
                checked={isCheckboxChecked}
                onChange={handleCheckboxChange}
            /> &nbsp; By submitting this order, I confirm that {copmanyName} meets all regulatory requirements, including adhering to local, state, federal and international laws, to order and utilize these numbers and/or features.
            </label>
            <br />
        </div>}
        <div className="row footer-row">
            <div className="footer-row-left">
                <a href="#" onClick={onBack} className="Back"> <img src="images/back-arrow.png" />Back</a>
            </div>
            <div className="footer-row-right">
            <Link className="Cancel" to={"/number-management"}>Cancel</Link>
                <a href="#" onClick={handleNext} className={buttonDisabled ? 'next disabled-link' : 'next'} >Complete Order</a>
            </div>
        </div>
    </>
)};

export default Step3;